<template>
  <v-expansion-panel expand>
    <v-expansion-panel-content value="true">
      <div slot="header">
        <v-layout row align-center justify-start>
          <v-flex xs6>
            <strong>Auto de Infração: </strong>
            <template v-if="showDueDate">
              <span class="badge green darken-1" v-if="remainingDays > 0">
                {{ remainingDays }} dias restantes
              </span>
              <span class="badge red darken-1" v-else>
                Prazo expirado
              </span>
            </template>
          </v-flex>
        </v-layout>
      </div>

      <v-card class="grey lighten-4 document-list">
        <v-card-text>
          <v-card subheader v-for="(item, index) in items" :key="index">
            <v-layout class="py-3 px-1" align-center>
              <v-flex class="text-xs-center" xs1>
                <v-icon>mdi-file mdi-24px</v-icon>
              </v-flex>
              <v-flex xs8>
                {{ item.name }}
              </v-flex>
              
              <v-flex class="text-xs-right" xs3>
                <v-layout justify-end column class="file-btn">
                  <input
                    type="file"
                    ref="inputDoc"
                    accept="application/pdf"
                    @change="processFileOptional($event, item.document, index)"
                  >
                  <v-btn
                    small
                    color="primary"
                    v-if="!hasDocument(item) && isAdmin"
                    @click="clickedItem(index)"
                  >
                    <v-icon left>mdi-cloud-upload</v-icon>
                    <span>Selecionar</span>
                  </v-btn>

                  <v-btn
                    small
                    flat
                    color="primary"
                    v-if="hasDocument(item)"
                    @click="loadFile(item.document)"
                  >
                    <span>Visualizar</span>
                  </v-btn>

                  <v-btn
                    small
                    outline
                    color="red"
                    v-if="hasDocument(item) && isAdmin"
                    @click="deleteDocumentVersion(item)"
                  >
                    <span>Remover</span>
                  </v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-divider/>
          </v-card>
        </v-card-text>

        <v-card-actions v-if="canBePaid" class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="success" @click="markAsPaid">
            Atualizar para pago
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import InfractionNoticesService from '@/services/applications/InfractionNoticesService.vue';
import AS from '@/services/AuthenticationService';
import { isEmpty } from 'lodash';
import moment from 'moment';
import axios from 'axios';

export default {
  name: 'InfractionNoticeDocument',
  props: ['isAdmin', 'application'],
  data() {
    return {
      isEmpty,
      isUploading: false,
      uploadPercentage: 0,
      items: [
        {name: 'Auto de Infração', type: 'document', document: { url: null }},
        {name: 'Boleto', type: 'billet', document: { url: null}},
      ],
    }
  },
  mounted() {
    this.loadDocuments();
  },
  methods: {
    processFileOptional(event, document, index) {

      const file = event.target.files[0];
      this.$refs.inputDoc[index].value = null;

      const headers = AS.getDefaultHeaders();
      headers.headers['Content-Type'] = 'multipart/form-data';

      const formData = new FormData();
      const type = this.items[index].type;
      formData.append(type, file);

      const config = {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          this.uploadPercentage = percentCompleted;
        },
        headers: headers.headers,
      };

      const doc = this.items[index].type == 'document' ? 'documento' : 'boleto';
      axios.put(`admin/requerimentos/${this.application.id}/auto-de-infracao/${doc}`, formData, config)
        .then((response) => {
          const type = this.items[index].type;
          this.items[index].document = response.data[type];
        })
        .catch((response) => {
          this.$store.dispatch('toggleSnackbar', {
            show: true,
            color: 'error',
            message: response.data.join(', '),
            messageIcon: 'mdi-alert-circle',
          });
        })
        .finally(() => {
          this.isUploading = false;
          this.uploadPercentage = 0;
        });
    },
    clickedItem(index) {
      this.$refs['inputDoc'][index].click();
    },
    loadFile(document) {
      window.open(document.url, '_blank');
    },
    deleteDocumentVersion(item) {
      const doc = item.type == 'document' ? 'documento' : 'boleto';

      const config = AS.getDefaultHeaders();
      config.headers['Content-Type'] = 'application/json';
      axios.put(`admin/requerimentos/${this.application.id}/auto-de-infracao/${doc}`, null, config)
        .then(() => {
          item.document = {};
        })
        .catch((response) => {
          this.$store.dispatch('toggleSnackbar', {
            show: true,
            color: 'error',
            message: response.data.join(', '),
            messageIcon: 'mdi-alert-circle',
          });
        });
    },
    loadDocuments() {
      this.items.forEach((item) => {
        item.document = this.infractionNotice[item.type]
      })
    },
    hasDocument(item) {
      return !isEmpty(item.document) && !!item.document.url;
    },
    markAsPaid() {
      InfractionNoticesService
      .changeInfractionNoticeToPaid(this.application.id)
      .then((response) => {
        this.$store.dispatch('toggleSnackbar', {
            show: true,
            color: 'success',
            message: response.data.message,
            messageIcon: 'mdi-check-circle',
          });
        this.$router.go();
      });
    }
  },
  computed: {
    infractionNotice() {
      return this.application.infraction_notice;
    },
    canBePaid() {
      return this.isAdmin &&
      this.application.status != 'done' &&
      this.application.status != 'waiting_to_be_sent';
    },
    showDueDate() {
      return this.infractionNotice.due_date != null && this.application.status != 'done';
    },
    remainingDays() {
      if (this.infractionNotice.due_date) {
        const currentDate = moment(new Date());
        const dueDate = moment(this.infractionNotice.due_date);
        const duration = moment.duration(dueDate.diff(currentDate));
        return Math.ceil(duration.asDays());
      }
      return 0;
    }
  },
  watch: {
    application() {
     this.loadDocuments();
    }
  }
}
</script>